import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=47abda0c&scoped=true"
import script from "./AdminDetails.vue?vue&type=script&lang=js"
export * from "./AdminDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminDetails.vue?vue&type=style&index=0&id=47abda0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abda0c",
  null
  
)

export default component.exports